/**
 * HeroReducedMotion — quiet branch for `prefers-reduced-motion: reduce`.
 *
 * Three keyframe stills are stacked, IntersectionObserver toggles which is
 * visible. No scroll-scrub, no transforms — opacity only.
 *
 * Visually credible: still tells the story of the unfold + interior reveal,
 * but without amplitude-heavy motion that would violate WCAG 2.3.3.
 */

export function HeroReducedMotion() {
  return (
    <section className="hero hero--reduced" data-scene="cinema">
      <div className="hero-reduced__stack">
        {/* Frame A — closed monolith */}
        <figure className="hero-reduced__frame">
          <FrameA />
        </figure>
        {/* Frame B — panels partially open with light spilling */}
        <figure className="hero-reduced__frame">
          <FrameB />
        </figure>
        {/* Frame C — interior visible through the threshold */}
        <figure className="hero-reduced__frame">
          <FrameC />
        </figure>
      </div>
      <div className="hero-copy hero-copy--static">
        <p className="eyebrow">Brian Ellison Design — Melbourne, Florida</p>
        <h1 className="hero-copy__headline">
          Interiors composed like<br />
          <span className="display-italic">architecture</span>.
        </h1>
        <p className="subtitle">
          Multidisciplinary luxury interior design.
        </p>
        <a href="/projects" className="cta-primary">See the work</a>
      </div>
    </section>
  );
}

function FrameA() {
  return (
    <svg viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" width="100%" height="100%">
      <rect width="1920" height="1080" fill="#0a0805" />
      <g transform="translate(960, 540)">
        <rect x="-440" y="-440" width="880" height="880" fill="#1c1612" stroke="rgba(212,165,116,0.18)" strokeWidth="2" />
        <line x1="0" y1="-420" x2="0" y2="420" stroke="rgba(212,165,116,0.18)" strokeWidth="1" />
      </g>
    </svg>
  );
}
function FrameB() {
  return (
    <svg viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" width="100%" height="100%">
      <rect width="1920" height="1080" fill="#0a0805" />
      <defs>
        <radialGradient id="glow-b" cx="0.5" cy="0.5" r="0.4">
          <stop offset="0" stopColor="#f5dcb4" stopOpacity="0.5" />
          <stop offset="1" stopColor="#0a0805" stopOpacity="0" />
        </radialGradient>
      </defs>
      <ellipse cx="960" cy="540" rx="320" ry="220" fill="url(#glow-b)" />
      <g transform="translate(960, 540)">
        <rect x="-440" y="-440" width="220" height="880" fill="#1c1612" stroke="rgba(212,165,116,0.18)" strokeWidth="2" transform="rotate(-12, -330, 0)" />
        <rect x="220" y="-440" width="220" height="880" fill="#1c1612" stroke="rgba(212,165,116,0.18)" strokeWidth="2" transform="rotate(12, 330, 0)" />
      </g>
    </svg>
  );
}
function FrameC() {
  return (
    <svg viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" width="100%" height="100%">
      <defs>
        <linearGradient id="interior-grad-c" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#3a2818" />
          <stop offset="0.6" stopColor="#704d28" />
          <stop offset="1" stopColor="#1c1612" />
        </linearGradient>
        <radialGradient id="pendant-c" cx="0.5" cy="0.3" r="0.2">
          <stop offset="0" stopColor="#f5dcb4" stopOpacity="0.9" />
          <stop offset="1" stopColor="#f5dcb4" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="1920" height="1080" fill="url(#interior-grad-c)" />
      <ellipse cx="960" cy="380" rx="220" ry="220" fill="url(#pendant-c)" />
      <rect x="800" y="700" width="320" height="220" rx="6" fill="#2a1c14" />
    </svg>
  );
}
